import env from '@/assets/env';

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

const initPromise = new Promise( ( resolve, reject ) => {
	resolveInitPromise = resolve;
	rejectInitPromise  = reject;
} );

export default function init() {
	if ( initialized ) return initPromise;

	initialized = true;

	window.gmapsCallback = () => resolveInitPromise( window.google );

	const script = document.createElement( 'script' );
	script.async = true;
	script.defer = true;
	script.src = `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_MAPS_API_KEY}&libraries=places&callback=gmapsCallback`;
	script.onerror = rejectInitPromise;
	document.querySelector( 'head' ).appendChild( script );

	return initPromise;
}
